import { Phone, MessageCircle, Share2 } from "lucide-react";
import { whatsappLink } from "../lib/constants";

/**
 * Mobile-only sticky action bar on business detail pages.
 *
 * Pinned to the bottom of the screen with three actions:
 *   📞 Appeler  · 💬 WhatsApp  · 🔗 Partager
 *
 * Hidden on md+ (desktop already has these in the page body).
 */
export default function StickyActionBar({ business, onTrack }) {
  if (!business) return null;
  const phone = business.phone;
  const whatsapp = business.whatsapp || business.phone;
  const shareUrl = typeof window !== "undefined" ? window.location.href : "";

  const handleShare = async (e) => {
    e.preventDefault();
    onTrack?.("share");
    const data = {
      title: business.name,
      text: `${business.name} · Lokaso 🇬🇳`,
      url: shareUrl,
    };
    try {
      if (navigator.share) {
        await navigator.share(data);
      } else {
        await navigator.clipboard.writeText(shareUrl);
      }
    } catch (err) {
      if (process.env.NODE_ENV !== "production") {
        // eslint-disable-next-line no-console
        console.warn("[StickyShare] failed:", err?.message);
      }
    }
  };

  return (
    <div
      data-testid="sticky-action-bar"
      className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-white border-t border-stone-200"
      style={{
        paddingBottom: "max(env(safe-area-inset-bottom), 0px)",
        boxShadow: "0 -8px 24px -8px rgba(0,0,0,0.16)",
      }}
    >
      <div className="grid grid-cols-3 gap-2 p-3">
        {phone ? (
          <a
            href={`tel:${phone}`}
            onClick={() => onTrack?.("call")}
            className="flex flex-col items-center justify-center gap-1 py-2.5 rounded-xl text-white font-semibold"
            style={{ background: "#1A5C35" }}
            data-testid="sticky-call-btn"
          >
            <Phone className="w-5 h-5" />
            <span className="text-xs">Appeler</span>
          </a>
        ) : (
          <button
            disabled
            className="flex flex-col items-center justify-center gap-1 py-2.5 rounded-xl bg-stone-200 text-stone-400 font-semibold cursor-not-allowed"
            data-testid="sticky-call-btn-disabled"
          >
            <Phone className="w-5 h-5" />
            <span className="text-xs">Appeler</span>
          </button>
        )}

        {whatsapp ? (
          <a
            href={whatsappLink(whatsapp, business.name)}
            target="_blank"
            rel="noreferrer"
            onClick={() => onTrack?.("whatsapp")}
            className="flex flex-col items-center justify-center gap-1 py-2.5 rounded-xl text-white font-semibold"
            style={{ background: "#25D366" }}
            data-testid="sticky-whatsapp-btn"
          >
            <MessageCircle className="w-5 h-5" />
            <span className="text-xs">WhatsApp</span>
          </a>
        ) : (
          <button
            disabled
            className="flex flex-col items-center justify-center gap-1 py-2.5 rounded-xl bg-stone-200 text-stone-400 font-semibold cursor-not-allowed"
          >
            <MessageCircle className="w-5 h-5" />
            <span className="text-xs">WhatsApp</span>
          </button>
        )}

        <button
          onClick={handleShare}
          className="flex flex-col items-center justify-center gap-1 py-2.5 rounded-xl text-lokaso-dark font-semibold"
          style={{ background: "#E8A020" }}
          data-testid="sticky-share-btn"
        >
          <Share2 className="w-5 h-5" />
          <span className="text-xs">Partager</span>
        </button>
      </div>
    </div>
  );
}
